<div class="error">
  <div class="error-image">
    <img src="../../assets/img/no-connection.svg" alt="No Connection" />
  </div>

  <div translate class="error-main-text error-text">This service is currently not available</div>

  <div translate class="error-second-text error-text">
    Please contact your IT department or Schenck digital support
  </div>
</div>
